import React from 'react';
import "./index.css";
import { Link } from 'react-router-dom';

export const SignIn = () => {
  return (
    <div className='signInBanner'>
        <div className='signGrid container'>
            <div className='signLeft'>
                <div  className='signLeftContent'>
                <div className='signTitle'>SnapBid</div>
                <div className='signSubTitle'>
                    <span>Welcome Back to SnapBid</span>
                    <span>Log in to manage your bids, track updates, and explore listings.</span>
                </div>
                <form>
                    <div className='signInput'>
                        <label>Email</label>
                       <div> <input type="text" placeholder='eg: andrew123@gmail.com'/></div>

                    </div>
                     <div className='signInput'>
                        <label>Password</label>
                        <div><input type="text" placeholder='Enter Password'/></div>

                    </div>
                    <div className='rememberContainer'>
                        <div><input type="checkbox" /><span className='ms-1'>Remember Me</span></div>
                        <div>Forgot Password?</div>
                    </div>
                    <div className='btnSign'><Link to="/home"><button>Sign In</button></Link></div>
                    <div className='textDont'>Don’t have an account? <span ><a href='/signup' style={{color:'#2E5B3D',textDecoration:'none'}}>Sign Up</a></span></div>

                </form>

            </div>
            </div>
            <div className='signRight'>
                <div>Your Next Property Starts Here!</div>
                <div>Verified listings. Real buyers. Zero blind bidding.</div>
            </div>

        </div>
    </div>
  )
}
